import Client from './client';

export default class CourthouseProductSummaries extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getSearchAndItemsByItemNumber(itemNumber, options = {}) {
    return this.makeRequest(`${this.host}/courthouse/products/search/items/${itemNumber}`, options);
  }

}
